import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCategories, loadCategories } from '../features/categories/categorySlice';
import { useGetCategoriesQuery } from '../features/categories/categoriesApiSlice';

const useCategory = () => {
  const dispatch = useDispatch();
  const categoryFromStore = useSelector(selectCategories);
  
  // Only trigger query if store is empty
  const { data: categoryFromApi, isLoading, error } = useGetCategoriesQuery(undefined, {
    skip: categoryFromStore.length > 0
  });

  useEffect(() => {
    // If we got data from API and store is still empty, update store
    if (categoryFromApi && categoryFromStore.length === 0) {
      dispatch(loadCategories(categoryFromApi));
    }
  }, [categoryFromApi, categoryFromStore.length, dispatch]);

  return {
    category: categoryFromStore.length > 0 ? categoryFromStore : (categoryFromApi || []),
    isLoading: categoryFromStore.length === 0 && isLoading,
    error
  };
};

export default useCategory;